import "core-js/modules/es.array.concat.js";
import { service } from './service'; // 获取委外送货单单List

export function LoadData(data) {
  return service({
    url: 'OutsourcesDeliveryNote/LoadData',
    data: data,
    method: 'post'
  });
} // 获取委外送货单单明细

export function GetDetailList(query) {
  return service({
    url: 'OutsourcesDeliveryNote/GetDetailList',
    params: query,
    method: 'get'
  });
} // 保存委外送货单单

export function saveOrderInfo(data) {
  return service({
    url: 'OutsourcesDeliveryNote/SaveData',
    data: data,
    method: 'post'
  });
} // 查询ERP采购订单明细数据

export function GetErpPoList(query) {
  return service({
    // url: 'ScmErpPo/GetErpPoList',
    url: 'ScmErpPo/GetErpOsorderList',
    method: 'get',
    params: query
  });
} // 审核委外送货单单

export function AuditOrder(data) {
  return service({
    url: 'OutsourcesDeliveryNote/CheckBill',
    method: 'post',
    data: data
  });
} // 反审核

export function UnCheckBillOrder(data) {
  return service({
    url: 'OutsourcesDeliveryNote/UnCheckBill',
    method: 'post',
    data: data
  });
} // 作废

export function CancelBill(data) {
  return service({
    url: 'OutsourcesDeliveryNote/CancelBill',
    method: 'post',
    data: data
  });
} // 导出委外送货单单list
// export function ExportListData ({ ORGANIZE_ID }) {
//   return service({
//     url: `OutsourcesDeliveryNote/ExportListData?Data.ORGANIZE_ID=${ORGANIZE_ID}`,
//     method: 'post'
//   })
// }

export function ExportListData(data) {
  return service({
    url: 'OutsourcesDeliveryNote/ExportListData',
    method: 'post',
    data: data
  });
} // 导出送货单明细

export function ExportDetailData(_ref) {
  var ID = _ref.ID,
      ORGANIZE_ID = _ref.ORGANIZE_ID,
      EXPORT_FILE_NAME = _ref.EXPORT_FILE_NAME;
  return service({
    url: "OutsourcesDeliveryNote/ExportDetailData?MST_ID=".concat(ID, "&ORGANIZE_ID=").concat(ORGANIZE_ID, "&EXPORT_FILE_NAME=").concat(EXPORT_FILE_NAME),
    method: 'get'
  });
} // 状态转在途

export function PrintBill(data) {
  return service({
    url: 'OutsourcesDeliveryNote/PrintBill',
    method: 'post',
    data: data
  });
} // 下一张

export function GetLastById(params) {
  return service({
    url: 'OutsourcesDeliveryNote/GetLastById',
    method: 'get',
    params: params
  });
} // 上一张

export function GetNextById(params) {
  return service({
    url: 'OutsourcesDeliveryNote/GetNextById',
    method: 'get',
    params: params
  });
} // 获取送货单供应商邮箱

export function GetVendorEmail(params) {
  return service({
    url: 'OutsourcesDeliveryNote/GetVendorEmail',
    method: 'get',
    params: params
  });
}